export default __webpack_public_path__ + "static/media/vacuum.2f84ffa7.svg";